import { render } from "./ ModalpendingsuccessOther.vue?vue&type=template&id=6a058448"
import script from "./ ModalpendingsuccessOther.vue?vue&type=script&lang=js"
export * from "./ ModalpendingsuccessOther.vue?vue&type=script&lang=js"

import "./ ModalpendingsuccessOther.vue?vue&type=style&index=0&id=6a058448&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__